import {
  combineReducers,
  configureStore,
  isRejectedWithValue,
} from "@reduxjs/toolkit";
// api slices
import { UserApi } from "src/redux/api-slices/user.api";
import { AuthApi } from "src/redux/api-slices/auth.api";
import { ProductApi } from "src/redux/api-slices/product.api";
import { ProjectApi } from "src/redux/api-slices/project.api";
import { TransactionApi } from "src/redux/api-slices/transaction.api";
import { MeetingsApi } from "src/redux/api-slices/meetings.api";
// reducer slices
import AuthReducer from "src/redux/actions-slices/auth.reducer";
import { GlobalErrorHandler } from "src/utils/apiHelper";
import { CertificateApi } from "./api-slices/certificate.api";

export const rtkQueryErrorLogger =
  (api: any) => (next: any) => (action: any) => {
    if (isRejectedWithValue(action)) {
      GlobalErrorHandler(action.payload);
    }
    return next(action);
  };

const rootReducer = combineReducers({
  [AuthApi.reducerPath]: AuthApi.reducer,
  [UserApi.reducerPath]: UserApi.reducer,
  [TransactionApi.reducerPath]: TransactionApi.reducer,
  [ProductApi.reducerPath]: ProductApi.reducer,
  [ProjectApi.reducerPath]: ProjectApi.reducer,
  [MeetingsApi.reducerPath]: MeetingsApi.reducer,
  [CertificateApi.reducerPath]: CertificateApi.reducer,
  auth: AuthReducer,
});

export const Store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(AuthApi.middleware)
      .concat(UserApi.middleware)
      .concat(TransactionApi.middleware)
      .concat(ProductApi.middleware)
      .concat(ProjectApi.middleware)
      .concat(MeetingsApi.middleware)
      .concat(CertificateApi.middleware)
      .concat(rtkQueryErrorLogger),
});

export type RootState = ReturnType<typeof Store.getState>;
export type AppDispatch = typeof Store.dispatch;
